import { OptimusProvider } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { Button, ButtonProps, IconName } from '@optimus-web/core';
import { useCentralProductForm } from '../../hooks/useCentralProductForm';
import { useHandleAssignProperty } from '../../hooks/useHandleAssignProperty';
import { AddProductToPropertyDialog } from '../_shared/AddProductToPropertyDialog';
import { CentralProductForm } from './CentralProductForm';

export const CreateCentralProductButton = ({ size, variant }: Omit<ButtonProps, 'type'>) => {
    const {
        handleAddToProperty,
        handleConfirm,
        handlers: assignHandlers,
        renderConfigureProductDialog,
        states: assignStates,
    } = useHandleAssignProperty();

    const {
        states: createProductStates,
        handlers: createProductHandlers,
        isPending,
        formErrors,
        handleSubmit,
    } = useCentralProductForm({ handleAddToProperty });

    return (
        <>
            <Button
                size={size}
                variant={variant}
                onClick={createProductHandlers.handleOpen}
                icon={IconName.Add}
                type="submit"
            >
                {lt('CreateProduct')}
            </Button>
            {createProductStates.isDialogOpened && (
                <CentralProductForm
                    isLoading={isPending}
                    active={createProductStates.isDialogOpened}
                    formErrors={formErrors}
                    onCancel={createProductHandlers.handleCancel}
                    onSubmit={handleSubmit}
                />
            )}

            {assignStates.isDialogOpened && (
                <AddProductToPropertyDialog
                    onConfirm={async () => {
                        await handleConfirm();
                        await createProductHandlers.handleConfirm();
                    }}
                    onCancel={() => {
                        // close both dialogs
                        assignHandlers.handleCancel();
                        createProductHandlers.handleCancel();
                    }}
                />
            )}
            <OptimusProvider density="spacious">{renderConfigureProductDialog()}</OptimusProvider>
        </>
    );
};
